enum localStorageReferences {
    HIDE_SURVEY = 'hideSurvey',
}

export { localStorageReferences };
